import React, { useEffect, useState } from "react";
import Layout from "../../../layout/Layout";
import { useDispatch, useSelector } from "react-redux";
import { setLoading } from "../../state/action/globalAction";
import { Typography } from "@mui/material";
import "../../tugFront/summary/frontsummary.scss";
import StaffObservation from "../../modal/StaffObservation";
import PatientRemark from "../../modal/PatientRemark";
import shareBtn from "../../../assets/sharebutton.svg";
import ShareReport from "../../modal/ShareReport";
import { getV5ReportSummary, usergetInfo } from "../../../services/romReports";
import { pageLocale } from "../../../utils/locale";
import SnackBar from "../../snack-bar/SnackBar";
import PdfSuccess from "../../modal/PdfSuccess";
import { SIDE_TUG_HISTORY } from "../../../routes/routerPath";
import {
  getParams,
  handleParams,
  removeMetricsParam,
} from "../../../utils/helpers";
import { useNavigate } from "react-router-dom";
import scoreTrend from "../../../assets/scoreTrend.svg";
import UserDetails from "../../tugFront/UserDetails";
import MetricsViewV2 from "../../tugFront/summary/MetricsViewV2";
import WellnessReportPopup from "../../modal/WellnessReportPopup";
import TugSideMetricsDetailsV2 from "./summary/TugSideMetricsDetailsV2";
const HIDE_SHARE_BTN_TUG_SIDE_V2 = false;

const SideSummaryV2 = () => {
  const [staffObservation, setStaffObservation] = useState(false);
  const [patientRemark, setPatientRemark] = useState(false);
  const [shareReport, setShareReport] = useState(false);
  const [reportData, setReportData] = useState(null);
  const [userData, setUserdata] = useState();
  const [successPopup, setSuccessPopup] = useState(false);
  const [openErrorAlert, setOpenErrorAlert] = useState({
    flag: false,
    text: null,
  });
  const [wellnessPopup, setWellnessPopup] = useState(false);

  const { errorCode, na } = pageLocale("common");
  const featureFlag = useSelector((state) => state.global.featureFlag);
  const { locale } = getParams();
  const navigate = useNavigate();
  const openErrorHandleClose = () => {
    setOpenErrorAlert({ flag: false, text: null });
  };

  const handleWellnessReportAccept = (dontShowAgain) => {
    // Store the preference if user checked "don't show again"
    if (dontShowAgain) {
      localStorage.setItem("wellnessReportDontShow", "true");
    }

    // Redirect to the same URL but without the metrics parameter
    const newUrl = removeMetricsParam();
    window.location.href = newUrl;
  };

  const handleWellnessReportClick = () => {
    // Check if user has previously chosen not to show the popup
    const dontShowAgain = localStorage.getItem("wellnessReportDontShow");

    if (dontShowAgain === "true" || locale === "ja") {
      // User previously chose not to show the popup or locale is Japanese, redirect directly
      const newUrl = removeMetricsParam();
      window.location.href = newUrl;
    } else {
      // Show the popup
      setWellnessPopup(true);
    }
  };

  const addObservation = (comment, rate) => {
    if (comment) {
      reportData.staffObservation = comment;
      reportData.staffObservationRating = Number(rate);
    }
    setStaffObservation(false);
  };
  const addPatient = (remark) => {
    if (remark) {
      reportData.patientsRemarks = remark;
    }
    setPatientRemark(false);
  };
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(setLoading(true));
    usergetInfo()
      .then((res) => {
        setUserdata(res.data?.data);
      })
      .catch((err) => {
        if (err.response?.status === 401 || err.response?.status === 403) {
          setOpenErrorAlert({ flag: true, text: errorCode });
        } else {
          setOpenErrorAlert({ flag: true, text: err.response?.data?.message });
        }
      });

    // Use V5 API for report summary data regardless of feature flag
    getV5ReportSummary()
      .then((res) => {
        dispatch(setLoading(false));
        // Ensure we pass the data object correctly
        setReportData(res?.data?.data);
      })
      .catch((err) => {
        dispatch(setLoading(false));
        if (err.response?.status === 401 || err.response?.status === 403) {
          setOpenErrorAlert({ flag: true, text: errorCode });
        } else {
          setOpenErrorAlert({ flag: true, text: err.response?.data?.message });
        }
      });
  }, []);
  const {
    view_score_trend,
    past_injury_surgery,
    equipment_used,
    staff_remarks,
    test_person_remarks,
    add_your_comment,
    add_diagnosis,
    recommended,
    disclaimer,
    optional,
    wellness_report_disclaimer,
  } = pageLocale("newreport");
  const mv2 = pageLocale("metricsv2");
  return (
    <>
      <Layout>
        <div className="front-tug-wrapper">
          {/* Show old user details and image only when feature flag is enabled */}
          {featureFlag && userData && (
            <UserDetails
              name={userData?.name}
              firstName={userData?.first_name}
              lastName={userData?.last_name}
              gender={userData?.gender}
              age={userData?.age}
              history
            />
          )}
          {featureFlag && (
            <>
              <div className="ai-img-wrapper">
                {reportData?.tumbnailPath && (
                  <img
                    src={reportData?.tumbnailPath}
                    alt="img"
                    className="tugside-img"
                  />
                )}
              </div>

              <div className="score-trend-wrapper">
                <button
                  className="trend-btn"
                  onClick={() => navigate(SIDE_TUG_HISTORY + handleParams())}
                >
                  {featureFlag
                    ? mv2?.view_measurement_trend || "View Measurement Trend"
                    : view_score_trend}{" "}
                  <img src={scoreTrend} alt="img" />
                </button>

                {/* Show Wellness Report button only when feature flag is enabled */}
                {featureFlag && (
                  <button
                    className="wellness-btn"
                    onClick={handleWellnessReportClick}
                  >
                    {mv2?.view_wellness_report || "View Wellness Report"}
                  </button>
                )}
              </div>
            </>
          )}

          {/* Show metrics view when feature flag is enabled */}
          {featureFlag && reportData && (
            <MetricsViewV2 reportData={reportData} reportType="side" />
          )}

          {/* Show new detailed metrics view when feature flag is disabled */}
          {!featureFlag && reportData && (
            <>
              <TugSideMetricsDetailsV2
                reportData={reportData}
                userData={userData}
                setOpenErrorAlert={setOpenErrorAlert}
              />

              {!HIDE_SHARE_BTN_TUG_SIDE_V2 && (
                <button
                  className="share-btn-all"
                  onClick={() => setShareReport(true)}
                >
                  <img src={shareBtn} alt="share" />
                </button>
              )}
            </>
          )}

          {/* Show existing remarks if they exist - always visible */}
          {(reportData?.staffObservation !== null ||
            reportData?.patientsRemarks !== null) && (
            <div className="success-staff-patient-comments">
              {reportData?.staffObservation && (
                <>
                  <div className="header">
                    <Typography className="title">{staff_remarks}</Typography>
                  </div>
                  <Typography className="comments">
                    {reportData?.staffObservation}
                  </Typography>
                </>
              )}
              {reportData?.staffObservation && reportData?.patientsRemarks && (
                <div className="divider"></div>
              )}
              {reportData?.patientsRemarks && (
                <>
                  <Typography className="title">
                    {test_person_remarks}
                  </Typography>
                  <Typography className="desc">
                    {reportData?.patientsRemarks
                      ? reportData?.patientsRemarks
                      : "NA"}
                  </Typography>
                </>
              )}
            </div>
          )}

          {/* Add Test Person Remark and Staff Remark sections - always visible */}
          {(!reportData?.staffObservation || !reportData?.patientsRemarks) && (
            <div className="main-wrapper">
              {!reportData?.staffObservation && (
                <>
                  <Typography className="title">
                    <span className="recommened-header-all">
                      {staff_remarks}
                    </span>
                    <span className="recommended-text">
                      ({featureFlag ? optional : recommended})
                    </span>
                  </Typography>
                  <button
                    className="custom-btn"
                    onClick={() => setStaffObservation(true)}
                  >
                    {add_your_comment}
                  </button>
                </>
              )}
              {!reportData?.staffObservation &&
                !reportData?.patientsRemarks && <div className="divider"></div>}
              {!reportData?.patientsRemarks && (
                <>
                  <Typography className="title">
                    <span className="recommened-header-all">
                      {test_person_remarks}
                    </span>
                    <span className="recommended-text">
                      ({featureFlag ? optional : recommended})
                    </span>
                  </Typography>
                  <button
                    className="custom-btn"
                    onClick={() => setPatientRemark(true)}
                  >
                    {add_diagnosis}
                  </button>
                </>
              )}
            </div>
          )}

          {/* Equipment used section - always visible */}
          <div className="main-wrapper">
            <Typography className="title">{past_injury_surgery}</Typography>
            <div className="injury-item">
              {reportData?.pastInjuryHistory.length > 0 ? (
                <Typography className="sub-info">
                  {reportData?.pastInjuryHistory.join(", ")}
                </Typography>
              ) : (
                <Typography className="sub-info">{na}</Typography>
              )}
            </div>
            <div className="divider"></div>
            <div className="sub-item">
              <Typography className="sub-title">{equipment_used}</Typography>
              {reportData?.equipmentUsed?.length > 0 ? (
                <Typography className="sub-info">
                  {reportData.equipmentUsed.join(", ")}
                </Typography>
              ) : (
                <Typography className="sub-info">{na}</Typography>
              )}
            </div>
          </div>

          {/* Disclaimer when feature flag is enabled */}
          {featureFlag && (
            <div className="disclaimer-section">
              <Typography className="disclaimer-text">{disclaimer}</Typography>
            </div>
          )}

          {/* Disclaimer when feature flag is disabled and language is not Japanese */}
          {!featureFlag && locale !== "ja" && (
            <div className="disclaimer-section">
              <Typography className="disclaimer-text">
                {wellness_report_disclaimer}
              </Typography>
            </div>
          )}
        </div>
      </Layout>
      <StaffObservation
        staffObservation={staffObservation}
        setStaffObservation={addObservation}
        reportIDData={reportData?.reportId}
      />
      <PatientRemark
        patientRemark={patientRemark}
        setPatientRemark={addPatient}
        reportIDData={reportData?.reportId}
      />
      {shareReport && (
        <ShareReport
          setShareReport={setShareReport}
          shareReport={shareReport}
          setSuccessPopup={setSuccessPopup}
          setOpenErrorAlert={setOpenErrorAlert}
        />
      )}
      <PdfSuccess
        successPopup={successPopup}
        setSuccessPopup={setSuccessPopup}
      />
      <SnackBar open={openErrorAlert} closeHandler={openErrorHandleClose} />
      <WellnessReportPopup
        isOpen={wellnessPopup}
        onClose={() => setWellnessPopup(false)}
        onAccept={handleWellnessReportAccept}
      />
    </>
  );
};

export default SideSummaryV2;
